export default __webpack_public_path__ + "static/media/35.23e07809.svg";